/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Core
import PropTypes from "prop-types";

// Components
import Box from "components/Atoms/Box";
import Input from "components/Atoms/Input/InputV1";
import Typography from "components/Atoms/Typography";

function InputDefault({ label, mt, mb, ml, mr, componentWidth, ...rest }) {
  return (
    <Box mt={mt} mb={mb} ml={ml} mr={mr} width={componentWidth}>
      <Box mb={1} ml={0.5} mt={0} lineHeight={0} display="inline-block">
        <Typography component="label" variant="caption" fontWeight="bold" textTransform="none">
          {label}
        </Typography>
      </Box>
      <Input onWheel={(e) => e.target.blur()} {...rest} />
    </Box>
  );
}

InputDefault.defaultProps = {
  mt: 0,
  mb: 1,
  ml: 0,
  mr: 0,
  componentWidth: "inherit",
};

InputDefault.propTypes = {
  label: PropTypes.string.isRequired,
  componentWidth: PropTypes.string,
  mt: PropTypes.number,
  mb: PropTypes.number,
  ml: PropTypes.number,
  mr: PropTypes.number,
};

export default InputDefault;
